module.exports = __webpack_public_path__ + "static/aboutbackground.c6c246db.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/aboutbackground.jpeg
// module id = 905
// module chunks = 3